import axios from 'axios'
import { get } from 'lodash'

class Http {
  req
  constructor() {
    const token = ''

    this.req = axios.create({
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        lang: localStorage.language
      }
    })

    this.req.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if (401 === get(error, 'response.status')) {
          window.location.assign('/login')
          return new Promise(() => {})
        } else if (403 === get(error, 'response.status')) {
          // Trigger unauthorized modal
          if (window.modalStore) {
            window.modalStore.openErrorModal('unauthorized')
          }
          return Promise.reject(error);
        } else if (500 === get(error, 'response.status')) {
          // Trigger server error modal
          if (window.modalStore) {
            window.modalStore.openErrorModal('server')
          }
          return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    });
  }

  setUser(token) {
    this.req.defaults.headers.Authorization = 'Bearer ' + token
  }

  removeToken() {
    this.req.defaults.headers.Authorization = null
  }
}

const http = new Http
const req = http.req
export default req
export { req, http }
